import React,{useEffect,useRef,useState} from 'react';
import Hls from 'hls.js';
import {api,useAuth} from '../context/AuthContext';
import {BACKEND_URL} from '../apiConfig';
export default function PrivateLivePlayer({path}){
 const ref=useRef(null),{user}=useAuth(),[failed,setFailed]=useState(false);
 useEffect(()=>{
  const video=ref.current;let hls;setFailed(false);
  const url=new URL(path,BACKEND_URL).href;
  if(!/^\/api\/live-media\/[a-f0-9]{64}$/.test(path)){setFailed(true);return;}
  if(Hls.isSupported()){
   hls=new Hls({xhrSetup:(xhr,requestUrl)=>{
    const u=new URL(requestUrl),origin=new URL(BACKEND_URL).origin;
    if(u.origin!==origin||!/^\/api\/live-media\/[a-f0-9]{64}$/.test(u.pathname)||u.search)throw new Error('Private media destination rejected');
    xhr.withCredentials=true;const token=api.defaults?.headers?.common?.Authorization;
    if(token)xhr.setRequestHeader('Authorization',token);
   }});hls.on(Hls.Events.ERROR,(_,data)=>{if(data.fatal)setFailed(true);});hls.loadSource(url);hls.attachMedia(video);
  }else if(video.canPlayType('application/vnd.apple.mpegurl')){video.crossOrigin='use-credentials';video.src=url;}
  else setFailed(true);
  return()=>{hls?.destroy();video.pause();video.removeAttribute('src');video.load();};
 },[path,user?.user_id]);
 return <>{failed&&<p role="alert">Özel yayın açılamadı. Oturumunuzu ve yayın durumunu kontrol edin.</p>}<video ref={ref} controls playsInline crossOrigin="use-credentials" className="aspect-video w-full" onError={()=>setFailed(true)} aria-label="Üyelere özel canlı yayın"/></>;
}
